
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/add",
      function () {
        return require("private-next-pages/admin/add.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/add"])
      });
    }
  